/**
 * AgentMesh brand mark — "Node-A": the letter A (for Agent) drawn as a graph of
 * connected nodes. Structure uses `currentColor` so it adapts to light/dark;
 * the green apex + lime node are the fixed brand accents.
 */
export function BrandMark({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" className={className} fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
        <line x1="20" y1="8" x2="10" y2="33" />
        <line x1="20" y1="8" x2="30" y2="33" />
        <line x1="15" y1="22" x2="25" y2="22" />
      </g>
      <circle cx="10" cy="33" r="3.1" fill="currentColor" />
      <circle cx="30" cy="33" r="3.1" fill="currentColor" />
      <circle cx="15" cy="22" r="2.7" fill="#c6f24e" />
      <circle cx="25" cy="22" r="2.7" fill="currentColor" />
      <circle cx="20" cy="8" r="4.4" fill="#10b981" />
    </svg>
  );
}

export default BrandMark;
